import type { Content } from '@neopolis/engine';

import { T } from '../textes-interface.js';

/**
 * Page « Mentions et données ».
 *
 * Règle non négociable n° 5 : ce que le jeu ne collecte pas doit être écrit
 * noir sur blanc, en français simple. Un chef d'établissement, un parent ou un
 * délégué à la protection des données doit pouvoir le lire sans intermédiaire.
 */
export function MentionsEtDonnees({
  content,
  onRetour,
}: {
  content: Content;
  onRetour: () => void;
}) {
  const sections = [
    { titre: T.mentions.donneesTitre, texte: T.mentions.donneesTexte },
    { titre: T.mentions.classeTitre, texte: T.mentions.classeTexte },
    { titre: T.mentions.cookiesTitre, texte: T.mentions.cookiesTexte },
    { titre: T.mentions.hebergementTitre, texte: T.mentions.hebergementTexte },
    { titre: T.mentions.conservationTitre, texte: T.mentions.conservationTexte },
    { titre: T.mentions.exportTitre, texte: T.mentions.exportTexte },
  ];

  return (
    <main className="mx-auto max-w-3xl space-y-6 p-6">
      <header className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-3xl font-bold text-slate-900">{T.mentions.titre}</h1>
        <button
          type="button"
          onClick={onRetour}
          className="min-h-touch rounded-xl bg-white px-4 font-semibold text-slate-700 shadow-sm"
        >
          {T.mentions.retour}
        </button>
      </header>

      <p className="text-slate-600">
        {content.meta.titre} — {content.meta.discipline}, {content.meta.niveau}
      </p>

      {sections.map((section) => (
        <section key={section.titre} className="rounded-2xl border-2 border-slate-200 bg-white p-5">
          <h2 className="text-xl font-bold text-slate-900">{section.titre}</h2>
          <p className="mt-2 text-slate-800">{section.texte}</p>
        </section>
      ))}

      <footer className="text-sm text-slate-600">
        <p>{content.meta.reference_programme.texte}</p>
      </footer>
    </main>
  );
}
